export const FacebookIcon = ({ color }: { color?: string }) => (
    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.14938 6.97645V12.0001H2.84169V6.97645H0.92453V4.93947H2.84169V4.19835C2.84169 1.44687 3.9911 0.00012207 6.42305 0.00012207C7.16861 0.00012207 7.355 0.119945 7.76329 0.217578V2.23237C7.30619 2.15249 7.17749 2.10811 6.70264 2.10811C6.13903 2.10811 5.83725 2.26787 5.5621 2.58296C5.28696 2.89805 5.14938 3.44391 5.14938 4.22497V4.94391H7.76329L7.0621 6.98089H5.14938V6.97645Z"
            fill={color ?? '#4267B2'}
        />
    </svg>
);
